import React, { ReactElement, useContext } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { HeaderContext } from '@/shared/contexts/Header';
import Link from '@/shared/ui/Link';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import ComputerRoundedIcon from '@mui/icons-material/ComputerRounded';
import ExploreOutlinedIcon from '@mui/icons-material/ExploreOutlined';
import StarsOutlinedIcon from '@mui/icons-material/StarsOutlined';

const iconMap : { [key : string] : any } = {
    HelpOutlineRounded: HelpOutlineRoundedIcon,
    InfoOutlined: InfoOutlinedIcon,
    LocalShippingOutlined: LocalShippingOutlinedIcon,
    AddCircleOutlineRounded: AddCircleOutlineRoundedIcon,
    ComputerRounded: ComputerRoundedIcon,
    ExploreOutlined: ExploreOutlinedIcon,
    StarsOutlined: StarsOutlinedIcon,
};

type Props = {};

const HeaderMenu : React.FC<Props> = () : ReactElement | null => {
    const { menuSection, dispatchMenuSection } = useContext(HeaderContext);

    return (
        <AnimatePresence>
            {
                (menuSection && menuSection.items.length > 0) && (
                    <motion.div
                        // initial={{ transform: 'translateY(-100%)' }}
                        animate={{ transform: 'translateY(0)', transition: { delay: 0.1, duration: 0.3 } }}
                        // exit={{ transform: 'translateY(-100%)', transition: { delay: 0.1, duration: 0.2 } }}
                        className='h-[calc(100vh-5rem)] fixed top-[3rem] lg:top-[5rem] w-full z-[998] backdrop-blur-sm'
                    >
                        <motion.div
                            initial={false}
                            animate={menuSection ? 'open' : 'closed'}
                            variants={{
                                open: {
                                    transition: {
                                        staggerChildren: 0.1,
                                        staggerDirection: 1,
                                    },
                                },
                            }}
                            className='bg-[#F5F7FC] py-[50px]'
                            onMouseLeave={() => {
                                dispatchMenuSection(null);
                            }}
                        >
                            <div className='mx-auto max-w-[900px] pl-2'>

                                { /* <div className='flex flex-row justify-between border-b-2 border-b-[#FFFFFF] py-[10px] mb-[30px]'>
                                    <h3 className='text-[#14274D] text-[24px] leading-[36px]'>
                                        {menuSection.name.translation.fallback}
                                    </h3>

                                    <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='none'
                                        viewBox='0 0 24 24'
                                        strokeWidth={1}
                                        stroke='#7041AC'
                                        className='w-8 h-8 cursor-pointer duration-300 hover:rotate-180'
                                        onClick={() => {
                                            dispatchMenuSection(null);
                                        }}
                                    >
                                        <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
                                    </svg>
                                </div> */ }
                                {
                                    menuSection.items.length > 0 && <div className='grid grid-flow-col auto-cols-max gap-x-32'>
                                        {
                                            menuSection.items.map((item, index) => {
                                                return (
                                                    <div key={index}>
                                                        {
                                                            item.title && (
                                                                <h5 className='text-[#14274D] text-[18px] font-semibold mb-[24px] flex items-center gap-2'>
                                                                    {item.icon && iconMap[item.icon] && React.createElement(iconMap[item.icon], { sx: { fontSize: 22, color: '#14274D' } })}
                                                                    {item.title.translation.fallback}
                                                                </h5>
                                                            )
                                                        }

                                                        <div className='grid grid-flow-row gap-[10px]'>
                                                            {
                                                                item.links.map((link, index) => {
                                                                    return (
                                                                        <motion.div
                                                                            key={index}
                                                                            whileHover={{ scale: 1.05 }}
                                                                            variants={{
                                                                                closed: { opacity: 0 },
                                                                                open: { opacity: 1 },
                                                                            }}
                                                                            className='w-fit'
                                                                        >
                                                                            <Link
                                                                                to={link.path}
                                                                                className='text-[#14274D] !font-normal'
                                                                            >
                                                                                {link.label.translation.fallback}
                                                                            </Link>
                                                                        </motion.div>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        }
                                    </div>
                                }
                            </div>
                        </motion.div>
                    </motion.div>
                )
            }
        </AnimatePresence>
    );
};

export default HeaderMenu;
